import { useDispatch, useSelector } from "react-redux";

import { selectQuoteBoxStructure } from "../redux/selector";
import { quotesActions } from "../redux/slice";
import { QuoteBoxStructurePatch } from "../types";

export const formKey = (suffix: string) => `QUOTES.DETAILS.FORM.${suffix}`;
export const boxKey = (suffix: string) => formKey(`BOX_STRUCTURE.${suffix}`);
export const NOTE = boxKey("FIELDS.NOTE");
export const TYPE_KEY = boxKey("FIELDS.TYPE");
export const HEIGHT_KEY = boxKey("FIELDS.HEIGHT_MM");
export const HEIGHT_OPTION = boxKey("FIELDS.HEIGHT_OPTION");

export const useQuoteBoxStructure = () => {
  const dispatch = useDispatch();
  const data = useSelector(selectQuoteBoxStructure);
  const patch: QuoteBoxStructurePatch = (key, value) =>
    dispatch(quotesActions.updateBoxStructure({ key, value }));

  return { data, patch };
};
